/*
 *  I04CALCULGSIMPCalcul.js
 *
 *  Created by Sébastien Hecart on 2019-05-12 10:16:06 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchCoeffGSimpl } from '@batical/data/src'
import { I04CALCULGSIMP_State } from '@batical/types/src'

function I04CALCULGSIMP_docalcul(state: I04CALCULGSIMP_State) {
  let res = fetchCoeffGSimpl(state.umurext, state.vitrage, state.plafond, state.plancher, state.configuration)

  if (res) {
    state.res_coeffDepVol = res.g
  } else {
    state.res_coeffDepVol = 0
  }
  state.invalidated = false
  return state
}

export default I04CALCULGSIMP_docalcul
